export const HSE_PRINT_STYLES = `
  @media print {
    nav, aside, header, .hse-no-print { display: none !important; }
    .hse-print-root {
      display: block !important;
      position: static !important;
      box-shadow: none !important;
      padding: 0 !important;
      margin: 0 !important;
      max-width: none !important;
    }
  }
`;

export function runWindowPrint() {
  window.print();
}
